export default __webpack_public_path__ + "static/media/icon-remove.a3f88cc5.svg";